(function () {
  'use strict';

  angular.module('app').component('resourceAvailabilityList', resourceAvailabilityList());

  function resourceAvailabilityList() {
    return {
      bindings: {
        resource: '<',
        // onResourceAvailabilityListUpdated: '&'
      },
      controller: ResourceAvailabilityListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/resources/resource-availabilities/resource-availability-list/resource-availability-list.component.html',
    };
  }

  ResourceAvailabilityListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'ResourceAvailabilityService',
  ];

  function ResourceAvailabilityListComponent(
    config,
    UtilService,
    AbilityService,
    ResourceAvailabilityService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_resourceavailability_accountadmin'),
      canUpdate: AbilityService.can('update_resourceavailability_accountadmin'),
      canDestroy: AbilityService.can('destroy_resourceavailability_accountadmin'),
    };

    vm.filterCriteria = ResourceAvailabilityService.getFilterCriteria();

    vm.dateDisplay = config.DATE_DISPLAY_SHORT;
    vm.hourDisplay = config.HOUR_DISPLAY; // Ex: 01:00 PM

    vm.$onInit = function () {
      // Initializers
      getResourceAvailabilities('');
    };

    // public methods
    // -----------------------
    vm.refresh = function () {
      vm.filterCriteria = ResourceAvailabilityService.getFilterCriteria();
      getResourceAvailabilities('');
    };

    vm.selectPage = function () {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      getResourceAvailabilities('');
    };

    vm.openResourceAvailabilityDetailModal = function (resourceAvailability) {
      const successCallback = (selectedItem) => {
        getResourceAvailabilities(selectedItem);

        // vm.onResourceAvailabilityListUpdated({ item: selectedItem });
      };

      resourceAvailability = resourceAvailability || {};

      ResourceAvailabilityService.openResourceAvailabilityDetailModal(
        resourceAvailability,
        vm.resource,
        successCallback
      ); // , vm.lastResourceAvailability
    };

    vm.changeResourceAvailabilityStatus = function (resourceAvailability) {
      if (!vm.permissions.canUpdate) return;

      ResourceAvailabilityService.changeResourceAvailabilityStatus(resourceAvailability);
    };

    vm.deleteResourceAvailability = function (resourceAvailability) {
      if (!vm.permissions.canDestroy) return;

      const successCallback = () => {
        // This is a hack, as for items added and then deleted the view has a latency - does not work
        // let index = vm.resourceAvailabilities.indexOf(resourceAvailability);
        // vm.resourceAvailabilities.splice(index, 1);

        getResourceAvailabilities('');
      };

      ResourceAvailabilityService.deleteResourceAvailability(resourceAvailability, successCallback);
    };

    // private methods
    // -----------------------
    function getResourceAvailabilities(selectedItem) {
      // vm.lastResourceAvailability = false;

      vm.loadingItems = true;
      ResourceAvailabilityService.getResourceAvailabilities(vm.resource.id, vm.filterCriteria).then(
        (data) => {
          vm.resourceAvailabilities = data.items;
          vm.meta = data.meta;

          // vm.lastResourceAvailability = ResourceAvailabilityService.latest;

          vm.loadingItems = false;

          if (selectedItem) {
            vm.UtilService.itemListChanged(selectedItem.id);
          }
        }
      );
    }

    /*function getLastResourceAvailability() {
            vm.loadedLastResourceAvailability = null;

            ResourceAvailabilityService.getResourceAvailabilities(vm.resource.id, { get: 'latest' }).then(() => {
                vm.lastResourceAvailability = ResourceAvailabilityService.items;

                // console.log(vm.lastResourceAvailability.start_date);
                // console.log(vm.lastResourceAvailability);

                vm.loadedLastResourceAvailability = true;
            });
        }*/
  }
})();
